export default {"src":"/_next/static/media/merge-icon.b00fc391.svg","height":66,"width":67,"blurWidth":0,"blurHeight":0};